export const activeMessageBackgroundColor = 'rgba(226, 226, 240)';
